import React, { Component } from "react";
import { Link } from "react-router-dom";
import PDF from "../assets/images/media/okas-mannual.pdf";
import "../css/supportRemoteAccess.css";
import Loader from './Loader';
import Clock from "../assets/images/clock-with-white-face.png";
class SupportRemoteRequest extends Component {
    constructor(props) {
        super(props);
        this.state = {
            okasBoxData: null,
            technician_id: '',
            loader: true,
            client_id: '',
            time_required: '',
            ticketHistory: [],
            status: ["hold", "closed", "open"], // Default status options
            selectedStatus: "", // Default selected status
            reply: "", // Store reply input
        };
    }

    // Fetch support ticket data
    fetchData = (url, token) => {
        // fetching ticket info
        fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            },
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }
                return response.json();
            })
            .then(data => {
                this.setState({ okasBoxData: data, selectedStatus: data.ticket_status });
                //fetching ticket history
                fetch(`/cloud/supportticket/ticket-history/${this.state.okasBoxData.ticket_id}/`, {
                    method: 'GET',
                    headers: {
                        'Authorization': token,
                        'Content-Type': 'application/json',
                    },
                })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Failed to fetch data');
                        }
                        return response.json();
                    })
                    .then(data => {
                        this.setState({ ticketHistory: data });
                    })
                    .catch(error => console.error('Error fetching data:', error));
            })
            .catch(error => console.error('Error fetching data:', error));



    };

    generateRemoteAccessToken = () => {
        const { technician_id, client_id, time_required } = this.state;


        // Extract project_id (building_id) from the state data
        const { building_id: projectId, remote_access_port } = this.state.okasBoxData.project_building;

        // Check if a token already exists for this project_id in localStorage
        const existingToken = localStorage.getItem(`remoteToken_${projectId}`);
        const existingTokenExpiresAt = localStorage.getItem(`remoteTokenExpiresAt_${projectId}`);

        if (existingToken && existingTokenExpiresAt) {
            // Parse the expiration time and compare it with the current time
            const expiresAt = new Date(existingTokenExpiresAt);
            const currentTime = new Date();

            // If the token has not expired, show an alert
            if (currentTime < expiresAt) {
                // console.log(remote_access_port)
                this.validateRemoteAccessToken(existingToken, projectId, remote_access_port)

            }
        } else {
            this.generateToken(projectId, remote_access_port)
        }

    };

    generateToken(projectId, remote_access_port) {
        const TokenValue = 'Token ' + localStorage.getItem("auth"); // Assuming token is stored in localStorage
        // If no existing token or the token is expired, proceed with token generation
        const csrfToken = document.cookie.split('; ').find(row => row.startsWith('csrftoken=')).split('=')[1];
        // const {building_id: projectId, project_building} = this.state.okasBoxData.project_building;
        const payload = {
            technician_id: 1,
            client_id: projectId,
            time_required: 48,  // Use the dynamic value from the state/
        };
        fetch('/cloud/generate-remote-access-token/', {
            method: 'POST',
            headers: {
                'Authorization': TokenValue,
                'Content-Type': 'application/json',
                'X-CSRFToken': csrfToken,
            },
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {
                if (data.token && data.expires_at) {
                    // Save the generated token and expiration time in localStorage
                    localStorage.setItem(`remoteToken_${projectId}`, data.token);
                    localStorage.setItem(`remoteTokenExpiresAt_${projectId}`, data.expires_at);
                    // console.log('Remote access token generated and saved:', data);
                    alert('redirecting to access');
                    // window.open(`http://proxy${remote_access_port}.tft.design?token=${data.token}`, "_blank")
                    // window.open(`/designstudioremoteaccess?token=${data.token}`)
                    window.location.href = `/designstudioremoteaccess?token=${data.token}`;

                } else {
                    console.error('Failed to generate token:', data);
                }
            })
            .catch(error => {
                console.error('Error generating remote access token:', error);
            });
    }

    validateRemoteAccessToken(token, projectId, remote_access_port) {
        const TokenValue = 'Token ' + localStorage.getItem("auth"); // Assuming token is stored in localStorage
        // If no existing token or the token is expired, proceed with token generation
        const csrfToken = document.cookie.split('; ').find(row => row.startsWith('csrftoken=')).split('=')[1];
        const payload = {
            token
        };
        fetch('/cloud/validate-remote-access-token/', {
            method: 'POST',
            headers: {
                'Authorization': TokenValue,
                'Content-Type': 'application/json',
                'X-CSRFToken': csrfToken,
            },
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {

                if (data.status === "valid") {

                    alert("redirecting to access")
                    // window.open(`http://proxy${remote_access_port}.tft.design?token=${token}`, "_blank")
                    // window.open(`/designstudioremoteaccess?token=${data.token}`)
                    window.location.href = `/designstudioremoteaccess?token=${data.token}`;

                } else {
                    alert("remote access time expired. request access again")
                    localStorage.removeItem(`remoteToken_${projectId}`);
                    localStorage.removeItem(`remoteTokenExpiresAt_${projectId}`);
                }
            })
            .catch(error => {
                console.error('Error generating remote access token:', error);
            });
    }

    componentDidMount() {
        // Extract ticket_id from URL
        const ticketId = window.location.pathname.split('/')[2];

        if (isNaN(ticketId)) {
            console.error('Invalid ticket_id:', ticketId);
            return;
        }

        let TokenValue = 'Token ' + localStorage.getItem("auth");
        this.fetchData(`/cloud/supportticket/${ticketId}`, TokenValue);
    }

    handleStatusChange = (e) => {
        this.setState({ selectedStatus: e.target.value });
    };

    handleReplyChange = (e) => {
        this.setState({ reply: e.target.value });
    };

    handleSubmit = () => {
        // Set the loading state
        this.setState({ isLoading: true, successMessage: "" });

        const TokenValue = 'Token ' + localStorage.getItem("auth");
        const csrfTokenCookie = document.cookie
            .split('; ')
            .find(row => row.startsWith('csrftoken='));

        const csrfToken = csrfTokenCookie ? csrfTokenCookie.split('=')[1] : null;

        fetch(`/cloud/supportticket/ticket-history/${this.state.okasBoxData.ticket_id}/`, {
            method: 'POST',
            headers: {
                'Authorization': TokenValue,
                'Content-Type': 'application/json',
                'X-CSRFToken': csrfToken,
            },
            body: JSON.stringify({
                status: this.state.selectedStatus,
                message: this.state.reply,
                user: "support@okas.ai", // Replace with dynamic value if needed
            }),
        })
            .then(response => response.json())
            .then(data => {
                //  console.log("Server Response:", data); // Log the response for debugging

                // Since the response contains a message, check if the message is "ticket history created"
                if (data.message === "ticket history created") {
                    this.setState({
                        isLoading: false,
                        successMessage: "ticket history created",

                    });
                    alert("Status Updated")

                    // Reload the page after a short delay
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000); // Adjust the delay as needed
                } else {
                    // console.error('Unexpected response:', data);
                    this.setState({ isLoading: false });
                    alert(data.message || 'Error while sending the reply.');
                }
            })
            .catch(error => {
                // console.error('Error while replying:', error);
                this.setState({ isLoading: false });
                alert('An error occurred. Please try again.');
            });
    };

    shareToOkas = () => {
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        // If no existing token or the token is expired, proceed with token generation
        const csrfToken = document.cookie.split('; ').find(row => row.startsWith('csrftoken=')).split('=')[1];
        fetch(`/cloud/assign-ticket-to-okas/${this.state.okasBoxData.ticket_id}/`, {
            method: 'POST',
            headers: {
                'Authorization': TokenValue,
                'Content-Type': 'application/json',
                'X-CSRFToken': csrfToken,
            }
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    // Save the generated token and expiration time in localStorage

                    alert('Assigned to OKAS');
                } else {
                    console.error('Error while assiging:', data);
                }
            })
            .catch(error => {
                console.error('Error while assigning:', error);
            });
    }

    getTimeDifference(timestamp) {
        const givenDate = new Date(timestamp); // Parse the given timestamp
        const currentDate = new Date(); // Get the current date and time
        const diffInMilliseconds = currentDate - givenDate; // Calculate the difference in milliseconds

        // Convert the difference to seconds, minutes, hours, and days
        const diffInSeconds = Math.floor(diffInMilliseconds / 1000);
        const diffInMinutes = Math.floor(diffInSeconds / 60);
        const diffInHours = Math.floor(diffInMinutes / 60);
        const diffInDays = Math.floor(diffInHours / 24);

        // Determine how to display the difference
        if (diffInMinutes < 60) {
            return `${diffInMinutes} minute(s)`;
        } else if (diffInHours < 24) {
            return `${diffInHours} hour(s)`;
        } else {
            return `${diffInDays} day(s)`;
        }
    }


    async handleWriteWithAi() {
        // Set loading to true when the request starts
        this.setState({ loading: true });

        const TokenValue = 'Token ' + localStorage.getItem("auth");
        const csrfToken = document.cookie.split('; ').find(row => row.startsWith('csrftoken=')).split('=')[1];

        try {
            // Make the API call
            let response = await fetch("/cloud/write-with-ai/", {
                method: 'POST',
                headers: {
                    'Authorization': TokenValue,
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken,
                },
                body: JSON.stringify({ text: this.state.reply }),
            });

            let result = await response.json();

            if (result.corrected_text) {
                // Update the reply state with corrected text if available
                this.setState({ reply: result.corrected_text });
            } else {
                alert("No text provided!");
            }
        } catch (error) {
           // console.log(error);
            alert("Service unavailable");
        } finally {
            // Set loading to false once the request is completed (either success or failure)
            this.setState({ loading: false });
        }
    }

    render() {
        const { okasBoxData } = this.state;
        console.log(okasBoxData);

        if (!okasBoxData) {
            return <div>  {this.state.loader ? <Loader /> : null}</div>;
        }

        return (
            <div className="supportBox">
                <div className="support-container">

                    <header className="header" style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginRight: '5%' }}>
                        <h1 style={{ width: '27%', textAlign: 'right', fontWeight: '700', fontSize: '15px' }}>
                            Support Center
                        </h1>
                        <p style={{ textAlign: 'right' }}>
                            Welcome to the world of smart living. Enter your OKAS<br />
                            credentials to take control of your intelligent home system<br />
                            and enjoy seamless automation at your fingertips.
                        </p>
                    </header>


                    <div className="main-content">
                        <div className="ticket" >
                            <h2 style={{ marginBottom: '4%', fontSize: '30px' }}>{(okasBoxData.custom_ticket_id).padStart(3, '0')}: Support Request</h2>

                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div className="textline" style={{ width: '60%' }}>
                                    <h5 style={{ fontWeight: "bold", color: "#707070", fontSize: '14px' }}>TICKET DETAILS</h5>
                                    <p>
                                        {okasBoxData.issue_description}
                                    </p>
                                </div>
                                <div className="projctflex" >
                                    <div className="project-details">
                                        <span

                                        >
                                            <h5 style={{ fontWeight: "bold", color: "#707070", fontSize: '14px' }}>PROJECT DETAILS</h5>
                                            <p style={{ color: '#707070' }}><strong style={{ color: "#707070", fontSize: '14px' }}>Project Name:</strong> {okasBoxData.project_building.building_name}</p>
                                            <p style={{ color: '#707070' }}><strong style={{ color: "#707070", fontSize: '14px' }}>Location:</strong> {okasBoxData.project_building.address.toUpperCase()}</p>
                                            <p style={{ color: '#707070' }}>
                                                <strong style={{ color: "#707070", fontSize: '14px' }}>Subscription Status:</strong>
                                                {okasBoxData.subscription_data === null ? "inactive" : " " + okasBoxData.subscription_data.status.charAt(0).toUpperCase() + okasBoxData.subscription_data.status.slice(1).toLowerCase()}
                                            </p>
                                            <p style={{ color: '#707070' }}><strong style={{ color: "#707070", fontSize: '14px' }}>Remote Access:</strong> {okasBoxData.remote_access ? "Enabled" : "Disabled"}</p>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {okasBoxData.ticket_status !== 'Closed' && (
                                
                                <div style={{ marginTop: '2%' }}>
                                    <a
                                        href={`/designstudioremoteaccess?port=${okasBoxData.project_building.remote_access_port}&project_id=${okasBoxData.subscription_data.project_building_id}`}
                                        className="access-button"
                                        style={{
                                            marginTop: '2%',
                                            padding: '10px 20px',
                                            borderRadius: '25px',
                                            display: 'block',
                                            backgroundColor: '#F5AE56',
                                            cursor: 'pointer',
                                            outline: 'none',
                                            textDecoration: 'none'
                                        }}
                                    >
                                        <div
                                            className="buttontext"
                                            style={{
                                                fontWeight: '500',
                                                borderRadius: "48px",
                                                border: "100"
                                            }}
                                        >
                                            Access Design Studio Remotely
                                        </div>
                                    </a>
                                </div>
                            )}

                            {/* <div className="reply-section" style={{border:'1px solid red'}}>
                                <label htmlFor="reply">Reply</label>

                                <textarea
                                    id="reply"
                                    placeholder="Write with AI"
                                    value={this.state.reply}
                                    onChange={this.handleReplyChange} />
                                <div className="statusselect">
                                    <label htmlFor="status">Status</label>

                                    <select
                                        id="status"
                                        value={this.state.selectedStatus}
                                        onChange={this.handleStatusChange}>
                                        {this.state.status.map((status, index) => (
                                            <option key={index} value={status}>{status}</option>
                                        ))}
                                    </select>
                                </div>

                                <button className="submit-button" onClick={this.handleSubmit}>
                                    Submit
                                </button>
                            </div> */}
                            <div className="reply-section">
                                <p htmlFor="reply" style={{ marginBottom: '5px', fontSize: '20px' }}>Reply</p>


                                <div style={{ position: "relative" }}>
                                    <textarea
                                        id="reply"
                                        placeholder=""
                                        value={this.state.reply}
                                        onChange={this.handleReplyChange}
                                        maxLength={300}
                                        style={{
                                            width: '100%',
                                            marginBottom: '10px',
                                            height: '120px',
                                            borderRadius: '10px',
                                            resize: 'none', // Optional: prevents resizing
                                            outline: 'none',
                                            backgroundColor: '#ebe3e3',
                                            paddingRight: '50px',  // Give space for the button on the right
                                            padding: '10px 100px 10px 10px',

                                        }}
                                    />


                                    <button
                                        onClick={this.handleWriteWithAi.bind(this)}
                                        style={{
                                            position: 'absolute',
                                            right: '0px',
                                            top: '0px',
                                            outline: 'none',
                                            border: 'none',
                                            background: 'transparent',
                                            borderRadius: '5px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        {this.state.loading ? (
                                            <div className="loader"></div>  // Show loader when loading is true
                                        ) : (
                                            'write with AI'  // Show text when not loading
                                        )}
                                    </button>

                                    {/* Add any additional styles for the loader */}
                                    <style>
                                        {`
.loader {
border: 4px solid #f3f3f3; /* Light grey */
border-top: 4px solid #f39522; /* Blue */
border-radius: 50%;
width: 20px;
height: 20px;
animation: spin 2s linear infinite;
}

@keyframes spin {
0% { transform: rotate(0deg); }
100% { transform: rotate(360deg); }
}
`}
                                    </style>

                                </div>


                                <div className="statusselect" style={{ marginBottom: '10px' }}>
                                    <p htmlFor="status" style={{ marginBottom: '5px', fontSize: '20px' }}>Status</p>
                                    <select
                                        id="status"
                                        value={this.state.selectedStatus}
                                        onChange={this.handleStatusChange}
                                        style={{
                                            width: '100%',
                                            padding: '8px',
                                            borderRadius: '5px',
                                            border: '1px solid #ccc',
                                            outline: 'none',
                                            backgroundColor: '#ebe3e3'
                                        }}
                                    >
                                        {this.state.status.map((status, index) => (
                                            <option key={index} value={status}>{status.charAt(0).toUpperCase() + status.slice(1)}</option>
                                        ))}
                                    </select>
                                </div>


                                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                                    <button
                                        style={{
                                            fontSize: "17px",
                                            fontWeight: "700",
                                            padding: "10px 20px",
                                            backgroundColor: this.state.isLoading ? "#ccc" : "",
                                            cursor: this.state.isLoading ? "not-allocloudd" : "pointer",
                                        }}
                                        className="submit-button"
                                        onClick={!this.state.isLoading ? this.handleSubmit : null}
                                        disabled={this.state.isLoading}
                                    >
                                        {/* {this.state.isLoading ? "Submitting..." : "Submit"} */}
                                        {this.state.isLoading ? (
                                            <div className="loader-text">
                                                Submitting<span className="dots-loader"></span>
                                            </div>
                                        ) : (
                                            "Submit"
                                        )}
                                    </button>
                                    {this.state.isLoading && (
                                        <div style={{ marginTop: "10px", marginRight: "5px" }}>
                                            <span
                                                style={{
                                                    width: "20px",
                                                    height: "20px",
                                                    border: "3px solid #f3f3f3",
                                                    borderTop: "3px solid #3498db",
                                                    borderRadius: "50%",
                                                    animation: "spin 1s linear infinite",
                                                }}
                                            ></span>
                                        </div>
                                    )}

                                </div>

                            </div>


                            {
                                this.state.ticketHistory.length > 0 &&
                                <div style={{ margin: "20px 0", fontFamily: "Arial, sans-serif" }}>
                                    <h2 style={{ textAlign: "center", color: "#333", marginBottom: "20px", fontSize: '30px' }}>
                                        Ticket History
                                    </h2>
                                    <table style={{ width: "100%", borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr style={{ backgroundColor: "#F28C19", color: "#fff" }}>
                                                <th style={{ padding: "10px", textAlign: "center", fontSize: "16px", backgroundColor: "#F28C19" }}>Status</th>
                                                <th style={{ padding: "10px", textAlign: "center", fontSize: "16px", backgroundColor: "#F28C19" }}>Message</th>
                                                <th style={{ padding: "10px", textAlign: "center", fontSize: "16px", backgroundColor: "#F28C19" }}>User</th>
                                                <th style={{ padding: "10px", textAlign: "center", fontSize: "16px", backgroundColor: "#F28C19" }}>Created At</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.ticketHistory.map((history, index) => (
                                                <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff" }}>
                                                    <td style={{ padding: "8px", textAlign: "center", border: "1px solid #ddd" }}>
                                                        {history.status}
                                                    </td>
                                                    <td style={{ padding: "8px", textAlign: "center", border: "1px solid #ddd" }}>
                                                        {history.message}
                                                    </td>
                                                    <td style={{ padding: "8px", textAlign: "center", border: "1px solid #ddd" }}>
                                                        {history.user}
                                                    </td>
                                                    <td style={{ padding: "8px", textAlign: "center", border: "1px solid #ddd" }}>
                                                        {new Date(history.created_at).toLocaleString()}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                            }

                        </div>
                        <div className="box-flex">
                            <div className="status-section">
                                <h3 style={{ fontSize: '17px', color: '#707070' }}>Status: {okasBoxData.ticket_status}</h3>
                                <p style={{ marginTop: '10%' }}>
                                    <img src={Clock} className="fa fa-clock-o" style={{ marginRight: "8px", width: '20px', height: '20px' }} />
                                    {this.getTimeDifference(okasBoxData.ticket_created_date)} Old Request
                                </p>
                                <ul>
                                    {/* <li style={{ marginTop: '10%' }}>
                                        <i className="fa fa-download" style={{ marginRight: "8px", fontSize: '21px' }}></i>
                                        <a href="#" style={{ textDecoration: 'none', color: '#707070' }}>Download Log Files</a>
                                    </li>
                                    <li style={{ marginTop: '10%' }}>
                                        <i className="fa fa-download" style={{ marginRight: "8px", fontSize: '21px' }}></i>
                                        <a style={{ textDecoration: 'none', color: '#707070', width: '100%' }} href="#">Download Diagnostic Report</a>
                                    </li> */}
                                    <li style={{ marginTop: '10%' }}>
                                        <i className="fa fa-download" style={{ marginRight: "8px", fontSize: '21px' }}></i>
                                        <a style={{ textDecoration: 'none', color: '#707070', width: '100%' }} target="_blank" href={okasBoxData.status_report}>Download Status Report</a>
                                    </li>
                                </ul>
                            </div>
                            {/* <div className="okas-section">
                                <div className="manual-links">
                                    <div className="link-item">
                                        <i style={{ fontSize: '21px' }} className="fa fa-download"></i>
                                        <a
                                            href={PDF}
                                            style={{ textDecoration: 'none', color: '#707070' }}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            OKAS Manual
                                        </a>
                                    </div>

                                    <div className="link-item">
                                        <i style={{ fontSize: '21px' }} className="fa fa-share"></i>
                                        <button style={{ backgroundColor: 'transparent', border: 'none', textAlign: 'left', color: '#707070' }} onClick={this.shareToOkas}>Share This Ticket to OKAS Support</button>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SupportRemoteRequest;
